import {Selector} from '@ngxs/store';
import {IGroup} from '@interfaces/group';
import {GroupsStateModel} from './groups-state.model';
import {GroupsState} from './groups.state';

export class GroupsSelectors {
  @Selector([GroupsState])
  static getGroups(state: GroupsStateModel): IGroup[] {
    return state.groups;
  }

  @Selector([GroupsState])
  static getGroupsInUse(state: GroupsStateModel): number {
    return state.groupsInUse;
  }

  @Selector([GroupsState])
  static getGroupsPerPage(state: GroupsStateModel): number {
    return state.groupsPerPage;
  }

  @Selector([GroupsState])
  static getCurrentPage(state: GroupsStateModel): number {
    return state.currentPage;
  }

  @Selector([GroupsState])
  static getGroupSearch(state: GroupsStateModel): string {
    return state.searchParam;
  }

  @Selector([GroupsState])
  static getSelectedGroup(state: GroupsStateModel): IGroup | null {
    return state.selectedGroup;
  }
}
